import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';

function __variableDynamicImportRuntime0__(path) {
  switch (path) {
    case './translations/de/de.json': return import('./translations/de/de.json.js');
    case './translations/dk/dk.json': return import('./translations/dk/dk.json.js');
    case './translations/fi/fi.json': return import('./translations/fi/fi.json.js');
    case './translations/fr/fr.json': return import('./translations/fr/fr.json.js');
    case './translations/frbe/frbe.json': return import('./translations/frbe/frbe.json.js');
    case './translations/nl/nl.json': return import('./translations/nl/nl.json.js');
    case './translations/nlbe/nlbe.json': return import('./translations/nlbe/nlbe.json.js');
    case './translations/no/no.json': return import('./translations/no/no.json.js');
    case './translations/se/se.json': return import('./translations/se/se.json.js');
    case './translations/temp/temp.json': return import('./translations/temp/temp.json.js');
    case './translations/uk/uk.json': return import('./translations/uk/uk.json.js');
    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }
var libraryInstance = i18n.createInstance();
libraryInstance.use(LanguageDetector).use(resourcesToBackend(function (language) {
  return __variableDynamicImportRuntime0__("./translations/".concat(language, "/").concat(language, ".json"));
})).init({
  debug: false,
  fallbackLng: 'se',
  domains: [{
    domain: 'localhost',
    defaultLocale: 'uk'
  }],
  react: {
    useSuspense: true,
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'ul', 'li', 'b', 'ol', 'i']
  }
});
if (window.Cypress) {
  libraryInstance.changeLanguage('uk');
}
var setLibraryLanguage = function setLibraryLanguage(lng) {
  libraryInstance.changeLanguage(lng);
};

export { libraryInstance as default, setLibraryLanguage };
